const GITHUB_BASE_URL = "https://github.com/mmyeon";

export const LINKS = {
  github: `${GITHUB_BASE_URL}`,
  blog: "https://blog.mmyeon.com/",
  email: "mmyeon.frontend@gmail.com",
  resume:
    "https://ritzy-phalange-090.notion.site/30da349f26f2803886a5c4a2ea60a616?pvs=73",
  projects: {
    yeokdoIn: {
      website: "https://yeokdo-in.mmyeon.com/",
      github: `${GITHUB_BASE_URL}/YeokdoIn`,
    },
    dogin: {
      website: "https://dogin.mmyeon.com/",
      github: `${GITHUB_BASE_URL}/dogin`,
    },
    yogalim: {
      website: "https://yogalim.mmyeon.com/",
      github: `${GITHUB_BASE_URL}/yogalim`,
    },
  },
};
